import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'UserSearchPipe', pure: false })
export class UserSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(user => {
          return user.name.search(searchText) !== -1
			  || user.lastname.search(searchText) !== -1
			  || user.username.search(searchText) !== -1;
      });
    }
  }
}